import * as Yup from 'yup';

export const updateUserSchema = Yup.object().shape({
    email: Yup.string().required('Please enter your email'),
    password: Yup.string().optional(),
    role: Yup.string().required('Please select role')
});